export default "__VITE_ASSET__CJO_eENd__"